module.exports = __webpack_public_path__ + "static/media/3.c4395bb4.JPG";